export default {
  data () {
    return {
      viewMenu: false,
      highlightShape: null,
      pasteEnable: false,
      pasteShapeData: null,
      pasteType: null,
      pageX: null,
      pageY: null
    }
  },
  computed: {
    contextMenu () {
      return {
        cut: { disabled: !this.overShape },
        copy: { disabled: !this.overShape },
        paste: { disabled: this.pasteDisabled, shape: this.listenPasteShape, type: this.listenPasteType, position: {x: null, y: null} },
        destroy: { disabled: !this.overShape }
      }
    },
    overShape () {
      return this.highlightShape && (this.highlightShape.attrs.name === 'crop_rect' || this.highlightShape.attrs.name === 'group_holder')
    },
    pasteDisabled () {
      return !this.pasteEnable
    },
    listenPasteShape () {
      return this.pasteShapeData
    },
    listenPasteType () {
      return this.pasteType
    }
  },
  methods: {
    bindContextMenuOpen: function () {
      let vm = this
      this.stage.on('contentContextmenu', function (e) {
        if (vm.select && this.targetShape) {
          vm.clearSelection()

          if (this.targetShape.parent.name() === 'group') {
            vm.highlightShape = this.targetShape.parent.findOne('.group_holder')
            vm.highlightSelection(vm.highlightShape)
          } else if (this.targetShape.attrs.name === 'crop_rect') {
            vm.highlightShape = this.targetShape
            vm.highlightSelection(vm.highlightShape)
          }

          vm.contextMenu.paste.position = vm.stage.getPointerPosition()
          vm.showMenu(e.evt)
        }
        e.evt.preventDefault()
      })
    },

    bindContextMenuClose: function () {
      let vm = this
      this.stage.on('click', function (e) {
        if (vm.select && e.target.attrs.name === 'baseRect') {
          vm.destroyTransformer()
          vm.clearSelection()
          vm.highlightShape = null
          vm.viewMenu = false
        }
      })
    },

    showMenu: function (e) {
      this.pageX = e.pageX
      this.pageY = e.pageY
      this.viewMenu = true
    },

    cutShape: function () {
      if (this.contextMenu.cut.disabled) { return }

      if (this.highlightShape.name() === 'group_holder') {
        this.pasteShapeData = this.highlightShape.parent
        this.pasteShapeData.hide()
      } else {
        this.pasteShapeData = this.highlightShape
        this.pasteShapeData.hide()
      }

      this.pasteType = 'cut'
      this.pasteEnable = true
      this.viewMenu = false
      this.drawLayer.draw()
    },

    copyShape: function () {
      if (this.contextMenu.copy.disabled) { return }

      if (this.highlightShape.name() === 'group_holder') {
        this.pasteShapeData = this.highlightShape.parent.clone()
      } else {
        this.pasteShapeData = this.highlightShape.clone()
      }

      this.pasteType = 'copy'
      this.pasteEnable = true
      this.viewMenu = false
    },

    pasteShape: function () {
      if (this.contextMenu.paste.disabled) { return }
      let position = {
        x: this.contextMenu.paste.position.x ? (this.contextMenu.paste.position.x / this.scaleScore) : (this.contextMenu.paste.shape.attrs.x + 30),
        y: this.contextMenu.paste.position.y ? (this.contextMenu.paste.position.y / this.scaleScore) : (this.contextMenu.paste.shape.attrs.y + 30)
      }
      if (this.contextMenu.paste.type === 'cut') {
        this.repositionShape(position)
        this.pasteEnable = false
        this.pasteShapeData = null
        this.highlightShape = null
      } else {
        this.createShape(position)
      }
      this.viewMenu = false
      this.pushToHistory()
    },

    createShape: function (position) {
      let shape = this.contextMenu.paste.shape.clone()

      if (shape.name() === 'group') {
        this.createDupGroup(shape, position)
      } else {
        let parent = this.drawLayer

        shape.setAttrs({
          id: 'new',
          x: position.x,
          y: position.y,
          path: parent.attrs.path + '.' + this.pathCount,
          edit_type: 'created',
          template_id: this.id
        })

        this.highlightShape = shape
      }

      this.pathCount++
      this.drawLayer.add(shape)
      this.drawLayer.draw()

      this.updateMappingData()
    },

    repositionShape: function (position) {
      let shape = this.pasteShapeData

      if (shape.name() === 'group') {
        this.repositionGroup(shape, position)
      } else {
        shape.setAttrs({
          x: position.x,
          y: position.y,
          x_pos: position.x,
          y_pos: position.y,
          stroke: this.theme[this.selectedTheme].strokeColor,
          shadowColor: false,
          shadowBlur: false,
          dash: false
        })
      }

      shape.show()
      this.drawLayer.draw()
    },

    destroyShape: function () {
      if (this.contextMenu.destroy.disabled) { return }
      this.removeShape()
      this.viewMenu = false
      this.updateMappingData()
      this.pushToHistory()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Train/contextMenu.js